const routes = [
    {
        path: '/sample',
        name: 'Sample',
        meta: {
            layout: 'basic',
        },
        component: () => import(/* webpackChunkName: "sample" */ '@/views/sample/sample-main.vue'),
        children: [
            {
                path: '/sample/sm001',
                name: 'Sm001',
                meta: {
                    layout: 'basic',
                },
                component: () => import(/* webpackChunkName: "sample" */ '@/views/sample/sm001.vue'),
            },
            {
                path: '/sample/sm002',
                name: 'Sm002',
                meta: {
                    layout: 'basic',
                },
                component: () => import(/* webpackChunkName: "sample" */ '@/views/sample/sm002.vue'),
            },
        ]
    },

]

export default routes;